import { P4MoveGenerator } from './P4MoveGenerator';
export class P4OrderedMoveGenerator extends P4MoveGenerator {
    getListMoves(node, config) {
        const halfWidth = (node.gameState.getWidth() - 1) / 2;
        function closestToCenterFirst(left, right) {
            const distanceFromCenterLeft = Math.abs(left.x - halfWidth);
            const distanceFromCenterRight = Math.abs(right.x - halfWidth);
            return distanceFromCenterLeft - distanceFromCenterRight;
        }
        return super.getListMoves(node, config).sort(closestToCenterFirst);
    }
}
